import { render } from "./Slide.vue?vue&type=template&id=5abce84c&scoped=true"
import script from "./Slide.vue?vue&type=script&lang=javascript"
export * from "./Slide.vue?vue&type=script&lang=javascript"

import "./Slide.vue?vue&type=style&index=0&id=5abce84c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5abce84c"

export default script